import {
  clampSlugForKey,
  clampToMaxLength,
  shortItemId,
  toUpperSnake,
} from './_uilm-key-internals';

/**
 * Build a UILM key for one option of a select / multiselect field.
 *
 * Options have no UDS ItemId, so the option's *value* is normalized to
 * UPPER_SNAKE_CASE and used as the trailing segment. Stable across
 * reordering; breaks if an admin renames the option — same trade-off
 * applies to any content-derived key.
 *
 * UILM rejects keys longer than 100 chars. For long option values we
 * truncate the readable tail and append `_H{6hex}` of the full
 * normalized value so two trimmed options can't collide. Short options
 * are emitted verbatim, so existing keys keep their names.
 *
 *   uilmKeyForOption('nda', 'a3f2b1c8-...', 'b7d3e9f1-...', 'Mergers & Acquisitions')
 *   → 'NDA_SCR_SA3F2B1C8_FLD_FB7D3E9F1_OPT_MERGERS_ACQUISITIONS'
 *
 *   uilmKeyForOption('employment-agreement', '…', '…',
 *     'Confidential Information Including Trade Secrets')
 *   → 'EMPLOYMENT_AGREEMENT_SCR_S…_FLD_F…_OPT_CONFIDENTIAL_INFORMATION_INCLUD_H1A2B3C'
 */
export function uilmKeyForOption(
  templateSlug: string,
  screenItemId: string,
  fieldItemId: string,
  optionValue: string,
): string {
  const prefix = [
    clampSlugForKey(templateSlug),
    'SCR',
    shortItemId(screenItemId, 'S'),
    'FLD',
    shortItemId(fieldItemId, 'F'),
    'OPT',
  ].join('_');

  return clampToMaxLength(prefix, toUpperSnake(optionValue));
}
